<template>
  <div class="add-creative">
    <div class="add-creative__content" v-loading="loading">
      <div>
        <div class="add-creative__title">Загрузить креативы</div>
        <div class="add-creative__reservation">
          <div class="add-creative__sub-title">Бронь</div>
          <Selector
            ref="creativeGroup"
            class="add-creative__selector add-creative__input form-input"
            limit-options-height
            :title="'Группа креативов'"
            :default-select-item-id="form.creativeGroupId || 'NoCreativeGroup'"
            :options="creativeGroupOptions"
            :select-fitrst-item="false"
            @handleChange="handleChangeCreativeGroup"
          />
          <div
            class="form-input"
            :class="{
              'form-input--full': form.creativeGroupName,
              'form-input--error': errors.creativeGroupName,
              'form-input--disabled': form.creativeGroupId,
            }"
          >
            <input v-model="form.creativeGroupName" type="text" :disabled="form.creativeGroupId" />
            <span class="form-input__label">Наименование группы*</span>
            <template v-if="errors.creativeGroupName && errors.creativeGroupName.length">
              <div v-for="error in errors.creativeGroupName" :key="error" class="form-input__error">
                {{ error }}
              </div>
            </template>
          </div>
          <Selector
            ref="typeContract"
            class="add-creative__selector add-creative__input form-input"
            required
            :title="'Тип рекламной компании*'"
            :options="Object.keys(AdType).map((key) => ({ id: key, name: AdType[key] }))"
            :select-fitrst-item="false"
            :disabled="!!form.creativeGroupId"
            :default-select-item-id="form.type"
            @handleChange="(val) => (form.type = val)"
          />
          <div class="add-creative__date-picker-group form-input">
            <div class="add-creative__date-picker-wrapper">
              <SingleDatePicker
                class="add-creative__date-picker"
                title="Дата начала"
                :class="{ 'form-input--disabled': form.creativeGroupId }"
                :disabled="!!form.creativeGroupId"
                :value="form.creativeGroupStartDate"
                @changeDates="changeCreativeGroupStartDate"
              />
              <template
                v-if="errors.creativeGroupStartDate && errors.creativeGroupStartDate.length"
              >
                <div
                  v-for="error in errors.creativeGroupStartDate"
                  :key="error"
                  class="form-input__error"
                >
                  {{ error }}
                </div>
              </template>
            </div>
            <div class="add-creative__date-picker-wrapper">
              <SingleDatePicker
                class="add-creative__date-picker"
                title="Дата окончания"
                :class="{ 'form-input--disabled': form.creativeGroupId }"
                :disabled="!!form.creativeGroupId"
                :value="form.creativeGroupEndDate"
                @changeDates="changeCreativeGroupEndDate"
              />
              <template v-if="errors.creativeGroupEndDate && errors.creativeGroupEndDate.length">
                <div
                  v-for="error in errors.creativeGroupEndDate"
                  :key="error"
                  class="form-input__error"
                >
                  {{ error }}
                </div>
              </template>
            </div>
          </div>
          <Selector
            ref="adForm"
            class="add-creative__selector add-creative__input form-input"
            required
            :disabled="!!form.creativeGroupId"
            :title="'Форма распространения*'"
            :default-select-item-id="form.form"
            :options="Object.keys(AdForm).map((key) => ({ id: key, name: AdForm[key] }))"
            :select-fitrst-item="false"
            @handleChange="(val) => changeAdForm(val)"
          />
          <div
            class="form-input"
            :class="{
              'form-input--full': form.description,
              'form-input--error': errors.description,
              'form-input--disabled': form.creativeGroupId,
            }"
          >
            <input v-model="form.description" type="text" :disabled="form.creativeGroupId" />
            <span class="form-input__label">Общее описание объекта рекламирования*</span>
            <Tooltip class="add-creative__tooltip">
              <div style="padding: 0 1rem">
                <b>Укажите:</b>
                <ul>
                  <li>Бренд (или несколько брендов) рекламируемых товаров или услуг;</li>
                  <li>Вид товара / услуги;</li>
                  <li>Дополнительную информацию.</li>
                </ul>
                <b style="display: block; margin-top: 0.5rem">Примеры:</b>
                <ul>
                  <li>“Tide.Стиральный порошок.Годовой запас в подарок.”</li>
                  <li>
                    “Отель «Ромашка». Бронирование номеров.Гостиница, отель в Подмосковье на
                    выходные.”.
                  </li>
                </ul>
              </div>
            </Tooltip>
          </div>
          <template v-if="errors.description && errors.description.length">
            <div v-for="error in errors.description" :key="error" class="form-input__error">
              {{ error }}
            </div>
          </template>

          <Selector
            ref="creativeGroup"
            class="add-creative__selector add-creative__input form-input"
            limit-options-height
            :title="'Категория товара/услуги*'"
            :default-select-item-id="form.kktuCodes.length ? form.kktuCodes[0] : null"
            :options="kktuOptions"
            hasSearch
            :disabled="!!form.creativeGroupId"
            :select-fitrst-item="false"
            @handleChange="handleChangeKktu"
          />
        </div>
        <div v-if="form.form" class="add-creative__creative">
          <div class="add-creative__sub-title">Креатив</div>
          <div
            v-for="(advertiserUrl, index) in form.advertiserUrls"
            :key="index"
            class="form-input"
            :class="{
              'form-input--full': form.advertiserUrls[index].length,
              'form-input--error': errors.advertiserUrls,
              'form-input--disabled': form.noTargetLinks,
            }"
          >
            <input
              :disabled="form.noTargetLinks"
              :value="advertiserUrl"
              @input="form.advertiserUrls.splice(index, 1, $event.target.value)"
              type="text"
            />
            <span class="form-input__label">Целевая ссылка</span>
            <div class="form-input__icons-group">
              <img
                v-if="index === 0"
                src="@/assets/icons/icon-add-gray.svg"
                class="form-input__icon-item"
                @click="form.advertiserUrls.push('')"
              />
              <img
                v-if="index !== 0"
                src="@/assets/icons/icon-close.svg"
                class="form-input__icon-item"
                @click="form.advertiserUrls.splice(index, 1)"
              />
            </div>
            <Tooltip class="add-creative__tooltip">
              <div style="padding: 0 1rem">
                <b>Целевая ссылка</b> – посадочная страница, которая ведет пользователя с креатива
                на ресурс Рекламодателя на страницу рекламируемого товара. Достаточно указать url
                конкретной страницы, но если utm метка влияет на вид страницы, то ссылку указываем с
                utm или добавляем несколько ссылок.
              </div>
            </Tooltip>
          </div>
          <template v-if="errors.advertiserUrls && errors.advertiserUrls.length">
            <div v-for="error in errors.advertiserUrls" :key="error" class="form-input__error">
              {{ error }}
            </div>
          </template>

          <div class="form-input">
            <label class="input__item-checkbox">
              <input type="checkbox" v-model="form.noTargetLinks" @change="changeNoTargetLinks" />
              <span class="input__item-checkbox__check">
                <img src="@/assets/icons/icon-done.svg" />
              </span>
              <span class="input__item-checkbox__info">
                <span class="input__item-checkbox__title"> Нет целевых ссылок </span>
              </span>
            </label>
          </div>
          <template v-if="form.form === AdFormKeys.TEXT || form.form === AdFormKeys.TEXT_GRAPHIC">
            <div
              v-for="({ textData }, index) in form.textData"
              :key="formDataTextUniqKeys[index]"
              class="form-input"
              :class="[{ 'form-input--full': textData }, { 'form-input--error': errors.textData }]"
            >
              <input
                :value="textData"
                @input="form.textData.splice(index, 1, { textData: $event.target.value })"
                type="text"
              />
              <span class="form-input__label">Текстовые данные креатива*</span>
              <div class="form-input__icons-group">
                <img
                  v-if="index === 0"
                  src="@/assets/icons/icon-add-gray.svg"
                  class="form-input__icon-item"
                  @click="
                    form.textData.push({ textData: '' });
                    formDataTextUniqKeys.push(getRandomInteger());
                  "
                />
                <img
                  v-if="index !== 0"
                  src="@/assets/icons/icon-close.svg"
                  class="form-input__icon-item"
                  @click="
                    form.textData.splice(index, 1);
                    formDataTextUniqKeys.splice(index, 1);
                  "
                />
              </div>
              <template v-if="errors.textData && errors.textData.length">
                <div v-for="error in errors.textData" :key="error" class="form-input__error">
                  {{ error }}
                </div>
              </template>
            </div>
          </template>
          <template v-if="form.form !== AdFormKeys.TEXT">
            <div
              v-for="(MediaDataItem, index) in form.mediaData"
              :key="MediaDataItem.fileContentBase64"
              class="add-creative__media-data"
            >
              <Selector
                ref="adForm"
                class="add-creative__selector add-creative__input form-input"
                required
                :disabled="!!form.creativeGroupId"
                :title="'Тип файла*'"
                :default-select-item-id="MediaDataItem.fileType"
                :options="
                  Object.keys(MediaFileTypeKey).map((key) => ({
                    id: MediaFileTypeValue[key],
                    name: MediaFileTypeName[key],
                  }))
                "
                :select-fitrst-item="false"
                @handleChange="(val) => changeMediaFileType(val, index)"
              />
              <div
                v-if="form.mediaData[index].fileType === MediaFileTypeValue[MediaFileTypeKey.IMAGE]"
                class="form-input"
                :class="{
                  'form-input--full': form.mediaData[index].description,
                  // 'form-input--error' : errors.creativeGroupName,
                }"
              >
                <input v-model="form.mediaData[index].description" type="text" />
                <span class="form-input__label">Описание изображения группы</span>
              </div>
              <div class="form-input">
                <div v-if="MediaDataItem.fileName" class="add-creative__upload-files">
                  <div class="add-creative__upload-files-item">
                    <span v-text="MediaDataItem.fileName" />
                    <button
                      class="add-creative__upload-files-delete"
                      @click="deleteMediaDateFileInfo(index)"
                    >
                      <img src="@/assets/icons/icon-close.svg" alt="" />
                    </button>
                  </div>
                </div>
                <label class="add-creative__upload">
                  <div class="button button--empty">Прикрепить файл*</div>
                  <input type="file" @change="checkFile($event, index)" />
                </label>
                <Tooltip class="add-creative__tooltip add-creative__tooltip-attached-to-bottom">
                  <div style="padding: 0 1rem">
                    Вам нужно загрузить один креатив, состоящий из одного файла. Загружаем один файл
                    (не архив) - получаем один токен. Вы можете выбрать сразу несколько файлов в
                    одной папке на Вашем компьютере удерживая shift (или ctrl). При этом на каждый
                    файл будет назначен отдельный токен.
                  </div>
                </Tooltip>
              </div>
              <ButtonElement
                v-if="index > 0"
                @click-button="form.mediaData.splice(index, 1)"
                ghost
                text="Удалить"
                class="add-creative__add-media-data"
              />
            </div>
            <ButtonElement
              @click-button="addMediaData"
              text="Добавить"
              class="add-creative__add-media-data"
            />
          </template>

          <div
            v-for="(AdditionalCreative, index) in form.additionalCreatives"
            :key="additionalCreativesKeys[index]"
            class="add-creative__additional-creative"
          >
            <div class="add-creative__delete-btn-wrapper">
              <button
                class="add-creative__upload-files-delete"
                @click="
                  form.additionalCreatives.splice(index, 1);
                  additionalCreativesKeys.splice(index, 1);
                "
              >
                <img src="@/assets/icons/icon-close.svg" alt="" />
              </button>
            </div>
            <div
              v-for="(advertiserUrl, index) in AdditionalCreative.advertiserUrls"
              :key="index"
              class="form-input"
              :class="{
                'form-input--full': AdditionalCreative.advertiserUrls[index].length,
                'form-input--error': errors.advertiserUrls,
                'form-input--disabled': AdditionalCreative.noTargetLinks,
              }"
            >
              <input
                :disabled="AdditionalCreative.noTargetLinks"
                :value="advertiserUrl"
                @input="AdditionalCreative.advertiserUrls.splice(index, 1, $event.target.value)"
                type="text"
              />
              <span class="form-input__label">Целевая ссылка</span>
              <div class="form-input__icons-group">
                <img
                  v-if="index === 0"
                  src="@/assets/icons/icon-add-gray.svg"
                  class="form-input__icon-item"
                  @click="AdditionalCreative.advertiserUrls.push('')"
                />
                <img
                  v-if="index !== 0"
                  src="@/assets/icons/icon-close.svg"
                  class="form-input__icon-item"
                  @click="AdditionalCreative.advertiserUrls.splice(index, 1)"
                />
              </div>
            </div>
            <div class="form-input">
              <label class="input__item-checkbox">
                <input
                  type="checkbox"
                  v-model="AdditionalCreative.noTargetLinks"
                  @change="AdditionalCreative.advertiserUrls = ['']"
                />
                <span class="input__item-checkbox__check">
                  <img src="@/assets/icons/icon-done.svg" />
                </span>
                <span class="input__item-checkbox__info">
                  <span class="input__item-checkbox__title"> Нет целевых ссылок </span>
                </span>
              </label>
            </div>
            <div
              class="form-input"
              :class="{
                'form-input--full': AdditionalCreative.mediaDataDescription,
              }"
            >
              <input v-model="AdditionalCreative.mediaDataDescription" type="text" />
              <span class="form-input__label">Описание изображения группы</span>
            </div>
            <div class="form-input">
              <div v-if="AdditionalCreative.mediaData.length" class="add-creative__upload-files">
                <div
                  v-for="(MediaDataItem, mediaDataIndex) in AdditionalCreative.mediaData"
                  :key="MediaDataItem.FileContentBase64"
                  class="add-creative__upload-files-item"
                >
                  <span v-text="MediaDataItem.FileName" />
                  <button
                    class="add-creative__upload-files-delete"
                    @click="AdditionalCreative.mediaData.splice(mediaDataIndex, 1)"
                  >
                    <img src="@/assets/icons/icon-close.svg" alt="" />
                  </button>
                </div>
              </div>
              <label class="add-creative__upload">
                <div class="button button--empty">Прикрепить файл(ы)</div>
                <input
                  multiple
                  type="file"
                  @change="checkFile($event, form.additionalCreatives[index].mediaData)"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="add-creative__group-btns">
        <template v-if="errors.global && errors.global.length">
          <div v-for="error in errors.global" :key="error" class="form-input__error">
            {{ error }}
          </div>
        </template>
        <div class="add-creative__btns-wrapper">
          <ButtonElement
            @click-button="createCreative"
            text="Сохранить"
            class="add-creative__save-btn"
            :disabled="isBtnDisabled"
          />
          <ButtonElement
            @click-button="closeDialog"
            class="add-creative__cancel-btn button--empty"
            :text="'Отменить'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonElement from '@/components/elements/ButtonElement';
import formValidate from '@/mixin/formValidate';
import Selector from '@/components/sort/Selector';
import numberWithSpaces from '@/mixin/numberWithSpaces';
import { ContractType, VatType, ContractVariant } from '@/utils/contracts';
import { getRandomInteger, toBase64 } from '@/utils/helpers';
import {
  cleanErrorMessage,
  AdType,
  AdForm,
  AdFormKeys,
  MediaFileTypeValue,
  MediaFileTypeName,
  MediaFileTypeKey,
  AdFormToMediaFileType,
} from '@/utils/creatives';
import SingleDatePicker from '@/components/sort/SingleDatePicker';
import fixDateFormat from '@/mixin/fixDate';
import { mapGetters, mapState, mapMutations } from 'vuex';
import Tooltip from '@/components/elements/Tooltip.vue';

const form = () => ({
  creativeGroupId: null,
  creativeGroupName: '',
  creativeGroupStartDate: null,
  creativeGroupEndDate: null,
  isSelfPromotion: false,
  finalContractId: null,
  type: '',
  form: '',
  advertiserUrls: [''],
  kktuCodes: [],
  description: '',
  isSocial: false,
  textData: [{ textData: '' }],
  okvedCodes: [],
  targetAudienceParams: {
    geo: [''],
  },
  mediaData: [],
  mediaDataDescription: null /* для всех объектов MediaData => Description  */,
  additionalCreatives: [],

  noTargetLinks: false,
});

const errors = () => ({
  creativeGroupName: null,
  creativeGroupStartDate: null,
  creativeGroupEndDate: null,
  isSelfPromotion: null,
  type: null,
  form: null,
  advertiserUrls: null,
  description: null,
  isSocial: null,
  targetAudienceParams: null,
  global: [],
});

export default {
  name: 'AddCreative',
  components: {
    ButtonElement,
    Selector,
    SingleDatePicker,
    Tooltip,
  },
  mixins: [fixDateFormat, formValidate, numberWithSpaces],
  data() {
    return {
      AdFormToMediaFileType,
      MediaFileTypeKey,
      MediaFileTypeValue,
      MediaFileTypeName,
      AdFormKeys,
      AdType,
      AdForm,
      ContractVariant,
      ContractType,
      VatType,
      form: form(),
      errors: errors(),
      loading: false,
      formDataTextUniqKeys: [getRandomInteger()],
      additionalCreativesKeys: [],
      searchValueByGEO: '',
      mediaFileType: null,
    };
  },
  computed: {
    ...mapState('Creatives', ['creativeGroups']),
    ...mapGetters('Creatives', ['getCreativeGroupById', 'getKktu']),

    getClientId() {
      return this.$route.query.clientId;
    },
    getFinalContractId() {
      return this.$route.query.finalContractId;
    },
    getInitialContractId() {
      return this.$route.query.initialContractId;
    },
    // getFiasObjectOptions() {
    //   return this.fiasObjects.map((fiasObject) => {
    //     const fiasObjectAlreadyAdded = this.form.targetAudienceParams.geo.find((objectGuid) => objectGuid === fiasObject.objectGuid)

    //     return {
    //       id: fiasObject.objectGuid,
    //       name: fiasObject.name,
    //       ...( fiasObjectAlreadyAdded && { disabledOption: true } )
    //     }
    //   })
    // },
    isBtnDisabled() {
      return !(
        this.form.creativeGroupName &&
        this.form.form &&
        this.form.kktuCodes.length &&
        this.form.description &&
        (this.textDataHasValue || this.mediaDataHasValue) &&
        (this.formHasAdditionalCreatives
          ? this.form.additionalCreatives.every((MediaDataItem) => MediaDataItem.mediaData.length)
          : true)
      );
    },
    creativeGroupOptions() {
      return [
        {
          id: 'NoCreativeGroup',
          name: '<Новая группа креативов>',
        },
        ...this.creativeGroups.map((item) => ({
          id: item.creativeGroupId,
          name: item.creativeGroupName,
        })),
      ];
    },
    mediaDataHasValue() {
      return !!this.form.mediaData.length;
    },
    formHasAdditionalCreatives() {
      return !!this.form.additionalCreatives.length;
    },
    textDataHasValue() {
      return !!this.form.textData.filter(({ textData }) => textData.length).length;
    },
    targetAudienceParamsHaveGeoValue() {
      return this.form.targetAudienceParams.geo.filter((fiasObject) => fiasObject.length);
    },
    kktuOptions() {
      return this.getKktu.map((kktu) => {
        return {
          id: kktu.code,
          name: `${kktu.code} ${kktu.name}`,
          disabledOption: kktu.level !== 3,
        };
      });
    },
  },
  methods: {
    ...mapMutations('Creatives', [
      'clearPagination',
      'clearFilters',
      'increaseTableComponentKey',
      'setPagination',
    ]),
    cleanErrorMessage,
    getRandomInteger,
    changeGeoOption(val, index) {
      this.form.targetAudienceParams.geo.splice(index, 1, val);
      this.searchValueByGEO = '';
    },
    addAdditionalCreative() {
      this.form.additionalCreatives.push({
        mediaDataDescription: null,
        advertiserUrls: [''],
        mediaData: [],
        noTargetLinks: false,
      });

      this.additionalCreativesKeys.push(this.getRandomInteger());
    },
    async prepareRequestToSend(payload) {
      if (this.formHasAdditionalCreatives) {
        const promises = [];
        const formatAdditionalCreatives = this.form.additionalCreatives.map(
          (additionalCreative) => ({
            ...payload,
            ...additionalCreative,
            mediaData: additionalCreative.mediaData.map((mediaDataItem) => ({
              ...mediaDataItem,
              description: additionalCreative.mediaDataDescription,
            })),
          })
        );

        /* создаем первый креатив, чтобы получить CreativeGroupId для AdditionalCreatives */
        await this.$store.dispatch('Creatives/createCreative', payload).then((createdCreative) => {
          formatAdditionalCreatives.map(async (creative) => {
            promises.push(
              this.$store.dispatch('Creatives/createCreative', {
                ...creative,
                creativeGroupId: createdCreative.creativeGroupId,
                finalContractId:
                  null /* если передаем CreativeGroupId, то MediaScout не требует finalContractId */,
                initialContractId:
                  null /* если передаем CreativeGroupId, то MediaScout не требует initialContractId */,
              })
            );
          });
        });

        return Promise.all(promises);
      } else {
        return this.$store.dispatch('Creatives/createCreative', payload);
      }
    },
    async createCreative() {
      this.loading = true;

      this.cleanErrors();
      const payload = {
        creativeGroupName: this.form.creativeGroupName,
        isSelfPromotion: this.form.isSelfPromotion,
        type: this.form.type,
        form: this.form.form,
        kktuCodes: this.form.kktuCodes,
        advertiserUrls: this.form.advertiserUrls.filter((avertiserUrl) => avertiserUrl.length),
        description: this.form.description,
        isSocial: this.form.isSocial,
        targetAudienceParams: this.targetAudienceParamsHaveGeoValue.length
          ? this.form.targetAudienceParams
          : null,
        ...(this.okvedCodes && {
          okvedCodes: this.form.okvedCodes.filter((okvedCode) => okvedCode.length),
        }),
        ...(this.mediaDataHasValue && {
          mediaData: this.form.mediaData.map((mediaDataItem) => ({
            ...mediaDataItem,
            Description: mediaDataItem.Description,
          })),
        }),
        ...(this.textDataHasValue && { textData: this.form.textData }),
        ...(this.getFinalContractId &&
          !this.form.creativeGroupId && { finalContractId: this.getFinalContractId }),
        ...(this.getInitialContractId &&
          !this.form.creativeGroupId && { initialContractId: this.getInitialContractId }),
        ...(this.form.creativeGroupStartDate && {
          creativeGroupStartDate: this.fixDateFormatNumbers(this.form.creativeGroupStartDate),
        }),
        ...(this.form.creativeGroupEndDate && {
          creativeGroupEndDate: this.fixDateFormatNumbers(this.form.creativeGroupEndDate),
        }),
        ...(this.form.creativeGroupId && { creativeGroupId: this.form.creativeGroupId }),
      };

      await this.prepareRequestToSend(payload)
        .then(() => {
          this.cleanData();
          this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: null });
          this.$notify({
            message: this.$t('new_app.success'),
            type: 'success',
          });

          this.clearPagination();
          this.clearFilters();
          this.$store
            .dispatch('Creatives/getCreatives', {
              ...(this.getFinalContractId && { finalContractId: this.getFinalContractId }),
              ...(this.getInitialContractId && { initialContractId: this.getInitialContractId }),
              ...(this.getClientId && { clientId: this.getClientId }),
            })
            .then((creatives) => {
              this.increaseTableComponentKey();

              this.setPagination({
                pageSize: 20,
                total: creatives.length,
                currentPage: 1,
              });
            });
        })
        .catch((error) => {
          this.errors.global = [this.cleanErrorMessage(error.detail)];
          this.$notify({
            message: this.cleanErrorMessage(error.detail),
            type: 'error',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cleanData() {
      this.$refs.adForm.selectedValue = null;
      this.form = { ...form() };
    },
    changeCreativeGroupStartDate(dateRange) {
      this.form.creativeGroupStartDate = dateRange.startDate;
    },
    changeCreativeGroupEndDate(dateRange) {
      this.form.creativeGroupEndDate = dateRange.startDate;
    },
    changeOkvedCodes(event) {
      this.form.okvedCodes = event.target.value.trim().split(',');
    },
    changeMediaFileType(val, index) {
      this.form.mediaData[index].description = null;
      this.form.mediaData[index].fileType = val;
    },
    deleteMediaDateFileInfo(mediaDataIndex) {
      this.form.mediaData[mediaDataIndex].fileContentBase64 = '';
      this.form.mediaData[mediaDataIndex].fileName = '';
      this.form.mediaData[mediaDataIndex].isArchive = false;
    },
    changeAdForm(val) {
      this.form.form = val;
      const { textData, advertiserUrls, additionalCreatives } = form();

      if (val !== AdFormKeys.TEXT) {
        this.form.mediaData = [
          {
            fileName: '',
            fileType: AdFormToMediaFileType[val],
            fileContentBase64: '',
            description: '',
            isArchive: false,
          },
        ];
      } else {
        this.form.mediaData = [];
      }

      this.form.textData = textData;
      this.form.advertiserUrls = advertiserUrls;
      this.form.additionalCreatives = additionalCreatives;
    },
    changeNoTargetLinks() {
      this.form.advertiserUrls = [''];
    },
    cleanErrors() {
      this.errors = errors();
    },
    addMediaData() {
      this.form.mediaData.push({
        fileName: '',
        fileType: AdFormToMediaFileType[this.form.form],
        fileContentBase64: '',
        description: '',
        isArchive: false,
      });
    },
    checkFile(e, index) {
      Array.from(e.target.files).map(async (file) => {
        const fileContentBase64 = await toBase64(file);
        this.form.mediaData[index].fileContentBase64 = fileContentBase64.split(',')[1];
        this.form.mediaData[index].fileName = file.name;
        this.form.mediaData[index].isArchive = file.type === 'application/zip';

        // form.push({
        //   fileType: this.mediaFileType,
        //   fileName: file.name,
        //   fileContentBase64: fileContentBase64.split(',')[1], /* strip type */
        //   description: this.form.mediaDataDescription,
        //   isArchive: file.type === 'application/zip',
        // })
      });
    },
    closeDialog() {
      this.cleanData();
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: false });
    },
    handleChangeKktu(id) {
      this.form.kktuCodes = [id];
    },
    handleChangeCreativeGroup(creativeGroupId) {
      this.cleanData();
      this.cleanErrors();

      const creative = this.getCreativeGroupById(creativeGroupId);

      if (creative) {
        this.$nextTick(() => {
          this.form = {
            ...this.form,
            kktuCodes: creative.kktuCodes,
            creativeGroupId: creative.creativeGroupId,
            isSocial: creative.isSocial,
            description: creative.description,
            type: creative.type,
            form: creative.form,
            okvedCodes: creative.okvedCodes,
            creativeGroupStartDate: creative.creativeGroupStartDate,
            creativeGroupEndDate: creative.creativeGroupEndDate,
            creativeGroupName: creative.creativeGroupName,
            targetAudienceParams: creative.targetAudienceParams || { geo: [''] },
          };
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.form-input--full .form-input__label {
  font-size: 1.2rem;
  line-height: 1.4rem;
  top: 0.6rem;
}

.form-input__icons-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
}

.form-input__icon-item {
  cursor: pointer;
  z-index: 1;
  width: 1.6rem;
  height: 1.6rem;
}

.add-creative {
  background: #fff;
  color: #000;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__add-media-data {
    margin-top: 2rem;
  }

  &__tooltip-attached-to-bottom {
    top: initial;
    bottom: 10px;
  }

  &__arrow-icon {
    cursor: pointer;
    transition: 0.3s ease-out;

    &--open {
      transition: 0.3s ease-out;
      transform: rotate(180deg);
    }
  }

  &__upload {
    margin: 1rem 0;
    input {
      display: none;
    }

    &-files {
      width: 100%;
      margin-bottom: 10px;

      &-item {
        padding: 1.4rem 0;
        border-bottom: 1px solid $gray7;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:last-child {
          border: none;
        }
      }

      &-delete {
        background: none;
        border: none;
      }
    }

    .button {
      font-weight: 400;
      color: var(--primary);
      background: #fff;
      font-size: 1.6rem;
      line-height: 1.9rem;
      border-radius: 4px;
      border: 1.5px solid var(--primary);
      min-width: 12.5rem;
      transition: 0.3s ease-out;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &:hover {
        color: #fff;
        background: var(--primary);
      }
    }
  }

  &__date-picker-group {
    display: flex;
    gap: 1.6rem;
    @include below($sm) {
      flex-direction: column;
    }
  }

  &__reservation {
    padding-bottom: 3.2rem;
  }

  &__media-data {
    margin-top: 4rem;

    &:first-child {
      margin-top: 2rem;
    }
  }

  &__creative,
  &__additional-creative {
    margin-top: 3rem;
    padding-top: 3rem;
    border-top: 0.1rem solid #d1d4d8;
  }

  &__delete-btn-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  &__date-picker-wrapper {
    width: 100%;
  }

  &__date-picker {
    width: 100%;
    background: $basicWhite;
  }

  &__input-icon {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }

  &__group-btns {
    display: flex;
    gap: 0.8rem;
    margin-top: 4.8rem;
    flex-direction: column;
  }

  &__btns-wrapper {
    display: flex;
    gap: 0.8rem;
  }

  &__delete-creative-btn {
    margin-bottom: 1rem;
  }

  &__btn {
    margin-top: 1rem;
    padding: 0 2rem;
  }

  &__save-btn {
    width: 17.4rem;
  }

  &__cancel-btn {
    width: 13.7rem;
  }

  textarea {
    font-family: 'Inter';
  }

  &__title {
    font-weight: 700;
    font-size: 4rem;
    line-height: 4.7rem;
    margin-bottom: 2.3rem;
    color: #000;
  }

  &__sub-title {
    font-size: 2rem;
    font-weight: 700;
    line-height: 2.3rem;
    margin-bottom: 2rem;
  }

  &__content {
    padding: 7rem;
    min-height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .selector__content {
    background: none;
    border: 1px solid #bfc2c6;
  }

  .selector__title {
    font-size: 1.6rem;
    color: #878b93;
  }
  &__input {
    .selector__content {
      width: 100%;
    }
  }

  .button {
    height: 5rem;
  }

  &__step {
    margin-bottom: 6rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    &-title {
      font-weight: 700;
      font-size: 2.2rem;
      line-height: 2.4rem;
      color: #333333;
      margin-bottom: 2rem;
    }

    &-content {
      .form-input {
        width: 100%;
        max-width: 35rem;

        @include below($sm) {
          max-width: 100%;
        }
      }
    }

    &-error {
      color: $redLight;
      position: absolute;
      left: 6rem;
    }
  }
}

@include below(993px) {
  .add-creative__title {
    font-size: 22px;
    line-height: 1.3;
    margin-bottom: 2.3rem;
  }

  .add-creative__step {
    margin-bottom: 30px;
  }

  .add-creative__final,
  .add-creative__content {
    padding: 15px;
    padding-right: 35px;
  }
}

@include below(769px) {
  .add-creative__final {
    .button {
      width: 100%;
      margin-top: 10px;
    }
  }
}
</style>
